<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ title() | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <textarea
          class="form-control"
          rows="5"
          [formControl]="notesFormControl"
          [placeholder]="placeholder() | translate"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="!notesFormControl.value"
      (click)="updateNotes()"
    >
      {{ 'common.buttons.btnUpdate' | translate }}
    </button>
  </div>
</div>
